// Inicializar al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  inicializarBotones();
  
  // Detectar clicks en eliminar
  document.addEventListener('click', function(e) {
    if (e.target.closest('cart-remove-button') || 
        e.target.closest('[data-cart-remove]') || 
        e.target.closest('.cart-item__remove')) {
      setTimeout(function() {
        actualizarTodoElCarrito();
      }, 500);
    }
  });
});

function inicializarBotones() {
  fetch('/cart.js')
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    actualizarBotonesSegunCarrito(cart);
  });
}

function addToCartLussam(button) {
  if (button.hasAttribute('disabled')) {
    return;
  }
  
  var variantId = button.getAttribute('data-variant-id');
  var maxInventory = parseInt(button.getAttribute('data-inventory'));
  
  // Verificar carrito actual antes de agregar
  fetch('/cart.js')
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    var cantidadEnCarrito = 0;
    cart.items.forEach(function(item) {
      if (item.variant_id == variantId) {
        cantidadEnCarrito = item.quantity;
      }
    });
    
    if (maxInventory > 0 && cantidadEnCarrito >= maxInventory) {
      bloquearBoton(button);
      return;
    }
    
    // Agregar al carrito
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      button.classList.add('success');
      
      // Actualizar carrito y animar encabezado
      actualizarTodoElCarrito();
      forzarAnimacionEncabezado();
      
      setTimeout(function() {
        fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cartActual) {
          var cantidadActual = 0;
          cartActual.items.forEach(function(item) {
            if (item.variant_id == variantId) {
              cantidadActual = item.quantity;
            }
          });
          
          if (maxInventory > 0 && cantidadActual >= maxInventory) {
            bloquearBoton(button);
          } else {
            desbloquearBoton(button);
          }
        });
      }, 2000);
    });
  });
}

function forzarAnimacionEncabezado() {
  fetch('/cart.js')
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    var cantidad = cart.item_count;
    
    if (cantidad > 0) {
      var cartLink = document.querySelector('#cart-icon-bubble');
      if (cartLink) {
        var bubble = cartLink.querySelector('.cart-count-bubble');
        
        // Si no existe la burbuja, crearla
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true">' + cantidad + '</span><span class="visually-hidden">' + cantidad + ' artículos</span>';
          cartLink.appendChild(bubble);
        } else {
          // Actualizar contenido
          var spans = bubble.querySelectorAll('span');
          spans.forEach(function(span) {
            if (span.getAttribute('aria-hidden') === 'true') {
              span.textContent = cantidad;
            } else {
              span.textContent = cantidad + ' artículos';
            }
          });
        }
        
        // Forzar visibilidad
        bubble.classList.remove('hidden');
        bubble.removeAttribute('hidden');
        bubble.style.display = 'flex';
        bubble.style.visibility = 'visible';
        bubble.style.opacity = '1';
        
        // Animar
        cartLink.classList.add('cart-animating');
        setTimeout(function() {
          cartLink.classList.remove('cart-animating');
        }, 600);
      }
    }
  });
}

function actualizarTodoElCarrito() {
  fetch('/cart.js')
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    var cantidad = cart.item_count;
    
    // Carrito flotante
    var floatingCount = document.getElementById('floating-cart-count');
    var floatingBtn = document.querySelector('.floating-cart-btn');
    if (floatingCount) {
      floatingCount.textContent = cantidad;
      floatingCount.style.display = cantidad > 0 ? 'flex' : 'none';
    }
    if (floatingBtn) {
      floatingBtn.classList.toggle('tiene-productos', cantidad > 0);
    }
    
    // Burbuja encabezado
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.querySelectorAll('span').forEach(function(span) {
        span.textContent = cantidad;
      });
      if (cantidad > 0) {
        bubble.classList.remove('hidden');
        bubble.style.display = 'flex';
      } else {
        bubble.classList.add('hidden');
      }
    }
    
    // Actualizar botones
    actualizarBotonesSegunCarrito(cart);
  });
  
  // Recargar drawer
  fetch('/?section_id=cart-drawer')
  .then(function(res) { return res.text(); })
  .then(function(html) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var nuevoDrawer = temp.querySelector('cart-drawer');
      if (nuevoDrawer) {
        cartDrawer.innerHTML = nuevoDrawer.innerHTML;
        cartDrawer.className = nuevoDrawer.className;
      }
    }
  });
}

function actualizarBotonesSegunCarrito(cart) {
  var itemsEnCarrito = {};
  
  cart.items.forEach(function(item) {
    itemsEnCarrito[item.variant_id] = item.quantity;
  });
  
  document.querySelectorAll('.lussam-btn-cart').forEach(function(btn) {
    var variantId = parseInt(btn.getAttribute('data-variant-id'));
    var maxInventory = parseInt(btn.getAttribute('data-inventory')) || 99999;
    var cantidadEnCarrito = itemsEnCarrito[variantId] || 0;
    
    if (maxInventory > 0 && cantidadEnCarrito >= maxInventory) {
      bloquearBoton(btn);
    } else {
      desbloquearBoton(btn);
    }
  });
}

function bloquearBoton(btn) {
  btn.setAttribute('disabled', 'true');
  btn.disabled = true;
  btn.style.setProperty('background', '#1b1f3a', 'important');
  btn.style.setProperty('cursor', 'not-allowed', 'important');
  btn.style.setProperty('opacity', '0.3', 'important');
  btn.style.setProperty('pointer-events', 'none', 'important');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
}

function desbloquearBoton(btn) {
  btn.removeAttribute('disabled');
  btn.style.background = '#1b1f3a';
  btn.style.cursor = 'pointer';
  btn.style.opacity = '1';
  btn.classList.remove('success');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
}